import React, { useEffect } from 'react';
import styles from './BeforeYouApplyModal.module.css';

const checkIcon = '/images/icons/eligibility-check.svg';
const warnIcon = '/images/icons/eligibility-warning.svg';

const BeforeYouApplyModal = ({ open, onClose }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [open]);

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div className={styles.panel} role="dialog" aria-modal="true" aria-labelledby="before-modal-title">
        <div className={styles.header}>
          {/* <h3 id="before-modal-title" className={styles.title}>Guardianship Eligibility</h3> */}
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className={styles.body}>
          <h3 id="before-modal-title" className={styles.title}>Guardianship Eligibility</h3>
          <p className={styles.subtitle}>Please ensure that you have reviewed the information below.</p>
          <p className={styles.subtitleMuted}>If you do not qualify for the criteria below, you’re application will be rejected.</p>

          <div className={styles.columnTitles}>
            <div className={styles.columnTitle}>You must meet the full criteria:</div>
            <div className={styles.columnTitle}>Unfortunately, you cannot:</div>
          </div>

          <div className={styles.columns}>
            <div className={styles.colLeft}>
              <div className={styles.list}>
                <div className={styles.item}>
                  <img className={styles.icon} src={checkIcon} alt="" />
                  <div className={styles.text}>Be 21 years old or over</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.item}>
                  <img className={styles.icon} src={checkIcon} alt="" />
                  <div className={styles.text}>Be in full-time employment/self-employed, earning £18k or more per annum</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.item}>
                  <img className={styles.icon} src={checkIcon} alt="" />
                  <div className={styles.text}>Be a responsible individual that is happy to live a flexible lifestyle</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.item}>
                  <img className={styles.icon} src={checkIcon} alt="" />
                  <div className={styles.text}>Understand the differences between Property Guardianship and a Tenancy Agreement</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.item}>
                  <img className={styles.icon} src={checkIcon} alt="" />
                  <div className={styles.text}>Be prepared to move in within 5 working days from the property viewing</div>
                </div>
              </div>
            </div>
            <div className={styles.colRight}>
              <div className={styles.list}>
                <div className={styles.itemWarn}>
                  <img className={styles.iconWarn} src={warnIcon} alt="" />
                  <div className={styles.text}>Be under 21 years old</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.itemWarn}>
                  <img className={styles.iconWarn} src={warnIcon} alt="" />
                  <div className={styles.text}>Live with anyone under 21 years old</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.itemWarn}>
                  <img className={styles.iconWarn} src={warnIcon} alt="" />
                  <div className={styles.text}>Be in part-time employment, on a zero-hour contract or be receiving financial support from the government</div>
                </div>
                <div className={styles.seprator} />
                <div className={styles.itemWarn}>
                  <img className={styles.iconWarn} src={warnIcon} alt="" />
                  <div className={styles.text}>Live with any pets</div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.noteEmphasis}>*Please note if you want to live with another individual, they also need to meet the full criteria</div>
        </div>
        {/* <div className={styles.footer}>
          <button type="button" className={styles.primaryCta} onClick={onClose}>Got it</button>
        </div> */}
      </div>
    </div>
  );
};

export default BeforeYouApplyModal;


